module.exports = __webpack_public_path__ + "img/status-late.7ed77526.svg";